var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-item-quantity" },
    [
      _c("span", [_vm._v(" " + _vm._s(_vm.$t("orderquantity")))]),
      _vm._v(" "),
      _c("global-button", {
        attrs: {
          theme: "secondary",
          icon: "minus",
          disabled: _vm.minusButtonDisabled,
        },
        on: {
          click: function ($event) {
            return _vm.minusItemCount()
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        class: _vm.ordercountTextColor,
        attrs: { type: "text", min: "1", size: "3" },
        domProps: { value: _vm.quantity },
        on: {
          input: function ($event) {
            return _vm.checkOrderMaxItems($event.target)
          },
        },
      }),
      _vm._v(" "),
      _c("global-button", {
        attrs: { theme: "secondary", icon: "plus" },
        on: {
          click: function ($event) {
            return _vm.plusItemCount()
          },
        },
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errorItemQuantity !== "",
            expression: "errorItemQuantity !== ''",
          },
        ],
        staticClass: "shop-item-quantity-error",
        domProps: { innerHTML: _vm._s(_vm.errorItemQuantity) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }